var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g4, _circle, _mask, _path25, _circle2, _mask2, _path26, _circle3, _mask3, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 623,
    height: 637,
    viewBox: "0 0 623 637",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.65 163.919C366.38 47.7741 473.399 201.676 503.592 251.633C503.677 251.773 503.733 251.922 503.772 252.081C512.724 289.147 586.184 260.456 612.247 403.238C623.403 464.351 532.682 620.538 388.666 580.149C277.893 549.083 15.8155 504.962 3.91065 378.817C-11.1912 218.796 165.099 284.558 267.65 163.919Z",
    stroke: "#9BCEF7",
    strokeWidth: 4.34138,
    strokeDasharray: "15.94 15.94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M327.555 380.093C346.894 380.093 362.571 364.416 362.571 345.078C362.571 325.74 346.894 310.063 327.555 310.063C308.217 310.063 292.54 325.74 292.54 345.078C292.54 364.416 308.217 380.093 327.555 380.093Z",
    fill: "#89E779"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306.65 346.627L311.831 341.142L320.364 349.065L342.306 327.428L348.096 333.523L320.364 361.56L306.65 346.627Z",
    fill: "#F4F8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_1681_5110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.87,
    y: 415.341,
    width: 159.546,
    height: 213.813,
    rx: 10.8535,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.413,
    y: 415.884,
    width: 158.46,
    height: 212.728,
    rx: 10.3108,
    stroke: "#C6D9FF",
    strokeWidth: 1.08535
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M377.272 472.881H331.919C330.957 472.881 330.034 472.499 329.354 471.818C328.673 471.138 328.291 470.215 328.291 469.253C328.291 468.29 328.673 467.367 329.354 466.687C330.034 466.007 330.957 465.624 331.919 465.624H377.272C378.234 465.624 379.157 466.007 379.837 466.687C380.518 467.367 380.9 468.29 380.9 469.253C380.9 470.215 380.518 471.138 379.837 471.818C379.157 472.499 378.234 472.881 377.272 472.881Z",
    fill: "#D6E5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M377.272 491.929H331.919C330.957 491.929 330.034 491.546 329.354 490.866C328.673 490.185 328.291 489.262 328.291 488.3C328.291 487.338 328.673 486.415 329.354 485.735C330.034 485.054 330.957 484.672 331.919 484.672H377.272C378.234 484.672 379.157 485.054 379.837 485.735C380.518 486.415 380.9 487.338 380.9 488.3C380.9 489.262 380.518 490.185 379.837 490.866C379.157 491.546 378.234 491.929 377.272 491.929Z",
    fill: "#D6E5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M309.956 499.998H275.122C273.985 499.997 272.894 499.602 272.09 498.899C271.286 498.196 270.833 497.243 270.832 496.25V460.333C270.833 459.339 271.286 458.386 272.09 457.683C272.894 456.981 273.985 456.585 275.122 456.584H309.956C311.093 456.585 312.184 456.981 312.988 457.683C313.792 458.386 314.245 459.339 314.246 460.333V496.25C314.245 497.243 313.792 498.196 312.988 498.899C312.184 499.602 311.093 499.997 309.956 499.998Z",
    fill: "#9FB3D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M376.956 530.931H274.46C273.498 530.931 272.575 530.549 271.895 529.868C271.214 529.188 270.832 528.265 270.832 527.303C270.832 526.34 271.214 525.418 271.895 524.737C272.575 524.057 273.498 523.674 274.46 523.674H376.956C377.433 523.674 377.904 523.768 378.345 523.951C378.785 524.133 379.185 524.4 379.522 524.737C379.859 525.074 380.126 525.474 380.308 525.914C380.491 526.354 380.584 526.826 380.584 527.303C380.584 527.779 380.491 528.251 380.308 528.691C380.126 529.131 379.859 529.531 379.522 529.868C379.185 530.205 378.785 530.472 378.345 530.655C377.904 530.837 377.433 530.931 376.956 530.931Z",
    fill: "#E3E3E3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M376.956 549.979H274.46C273.498 549.979 272.575 549.596 271.895 548.916C271.214 548.236 270.832 547.313 270.832 546.35C270.832 545.388 271.214 544.465 271.895 543.785C272.575 543.104 273.498 542.722 274.46 542.722H376.956C377.918 542.722 378.841 543.104 379.522 543.785C380.202 544.465 380.584 545.388 380.584 546.35C380.584 547.313 380.202 548.236 379.522 548.916C378.841 549.596 377.918 549.979 376.956 549.979Z",
    fill: "#E3E3E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M376.956 569.027H274.46C273.498 569.027 272.575 568.645 271.895 567.965C271.214 567.284 270.832 566.361 270.832 565.399C270.832 564.437 271.214 563.514 271.895 562.833C272.575 562.153 273.498 561.771 274.46 561.771H376.956C377.918 561.771 378.841 562.153 379.522 562.833C380.202 563.514 380.584 564.437 380.584 565.399C380.584 566.361 380.202 567.284 379.522 567.965C378.841 568.645 377.918 569.027 376.956 569.027Z",
    fill: "#E3E3E3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M376.956 588.075H274.46C273.498 588.075 272.575 587.693 271.895 587.012C271.214 586.332 270.832 585.409 270.832 584.446C270.832 583.484 271.214 582.561 271.895 581.881C272.575 581.2 273.498 580.818 274.46 580.818H376.956C377.918 580.818 378.841 581.2 379.522 581.881C380.202 582.561 380.584 583.484 380.584 584.446C380.584 585.409 380.202 586.332 379.522 587.012C378.841 587.693 377.918 588.075 376.956 588.075Z",
    fill: "#E3E3E3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1681_5110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.561,
    y: 164.626,
    width: 134.44,
    height: 180.167,
    rx: 9.14555,
    fill: "#F1F4F8"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M601.624 261.966H499.128C498.166 261.966 497.243 261.584 496.563 260.904C495.882 260.223 495.5 259.301 495.5 258.338C495.5 257.376 495.882 256.453 496.563 255.773C497.243 255.092 498.166 254.71 499.128 254.71H601.624C602.1 254.71 602.572 254.804 603.012 254.986C603.453 255.168 603.853 255.436 604.19 255.773C604.527 256.11 604.794 256.51 604.976 256.95C605.159 257.39 605.252 257.862 605.252 258.338C605.252 258.815 605.159 259.287 604.976 259.727C604.794 260.167 604.527 260.567 604.19 260.904C603.853 261.241 603.453 261.508 603.012 261.69C602.572 261.873 602.1 261.966 601.624 261.966Z",
    fill: "#E3E3E3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M601.624 281.014H499.128C498.166 281.014 497.243 280.632 496.563 279.951C495.882 279.271 495.5 278.348 495.5 277.386C495.5 276.424 495.882 275.501 496.563 274.82C497.243 274.14 498.166 273.758 499.128 273.758H601.624C602.586 273.758 603.509 274.14 604.19 274.82C604.87 275.501 605.252 276.424 605.252 277.386C605.252 278.348 604.87 279.271 604.19 279.951C603.509 280.632 602.586 281.014 601.624 281.014Z",
    fill: "#E3E3E3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M601.624 300.063H499.128C498.166 300.063 497.243 299.681 496.563 299C495.882 298.32 495.5 297.397 495.5 296.435C495.5 295.472 495.882 294.549 496.563 293.869C497.243 293.189 498.166 292.806 499.128 292.806H601.624C602.586 292.806 603.509 293.189 604.19 293.869C604.87 294.549 605.252 295.472 605.252 296.435C605.252 297.397 604.87 298.32 604.19 299C603.509 299.681 602.586 300.063 601.624 300.063Z",
    fill: "#E3E3E3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M601.624 319.111H499.128C498.166 319.111 497.243 318.728 496.563 318.048C495.882 317.367 495.5 316.444 495.5 315.482C495.5 314.52 495.882 313.597 496.563 312.917C497.243 312.236 498.166 311.854 499.128 311.854H601.624C602.586 311.854 603.509 312.236 604.19 312.917C604.87 313.597 605.252 314.52 605.252 315.482C605.252 316.444 604.87 317.367 604.19 318.048C603.509 318.728 602.586 319.111 601.624 319.111Z",
    fill: "#E3E3E3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M601.937 208.056H556.584C555.622 208.056 554.699 207.674 554.019 206.994C553.338 206.313 552.956 205.39 552.956 204.428C552.956 203.466 553.338 202.543 554.019 201.863C554.699 201.182 555.622 200.8 556.584 200.8H601.937C602.899 200.8 603.822 201.182 604.502 201.863C605.183 202.543 605.565 203.466 605.565 204.428C605.565 205.39 605.183 206.313 604.502 206.994C603.822 207.674 602.899 208.056 601.937 208.056Z",
    fill: "#D6E5FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M601.937 227.104H556.584C555.622 227.104 554.699 226.722 554.019 226.041C553.338 225.361 552.956 224.438 552.956 223.476C552.956 222.514 553.338 221.591 554.019 220.91C554.699 220.23 555.622 219.847 556.584 219.847H601.937C602.899 219.847 603.822 220.23 604.502 220.91C605.183 221.591 605.565 222.514 605.565 223.476C605.565 224.438 605.183 225.361 604.502 226.041C603.822 226.722 602.899 227.104 601.937 227.104Z",
    fill: "#D6E5FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M534.624 235.174H499.79C498.653 235.173 497.562 234.778 496.758 234.075C495.954 233.372 495.501 232.419 495.5 231.425V195.509C495.501 194.515 495.954 193.562 496.758 192.859C497.562 192.156 498.653 191.761 499.79 191.76H534.624C535.761 191.761 536.852 192.156 537.656 192.859C538.46 193.562 538.913 194.515 538.914 195.509V231.425C538.913 232.419 538.46 233.372 537.656 234.075C536.852 234.778 535.761 235.173 534.624 235.174Z",
    fill: "#9FB3D6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1681_5110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.063,
    y: 55.0065,
    width: 134.44,
    height: 180.167,
    rx: 9.14555,
    fill: "#F1F4F8"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M379.128 152.347H276.632C275.67 152.347 274.747 151.964 274.067 151.284C273.386 150.604 273.004 149.681 273.004 148.718C273.004 147.756 273.386 146.833 274.067 146.153C274.747 145.472 275.67 145.09 276.632 145.09H379.128C379.604 145.09 380.076 145.184 380.516 145.366C380.957 145.549 381.357 145.816 381.694 146.153C382.03 146.49 382.298 146.89 382.48 147.33C382.662 147.77 382.756 148.242 382.756 148.718C382.756 149.195 382.662 149.667 382.48 150.107C382.298 150.547 382.03 150.947 381.694 151.284C381.357 151.621 380.957 151.888 380.516 152.071C380.076 152.253 379.604 152.347 379.128 152.347Z",
    fill: "#E3E3E3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M379.128 171.394H276.632C275.67 171.394 274.747 171.012 274.067 170.332C273.386 169.651 273.004 168.728 273.004 167.766C273.004 166.804 273.386 165.881 274.067 165.2C274.747 164.52 275.67 164.138 276.632 164.138H379.128C380.09 164.138 381.013 164.52 381.694 165.2C382.374 165.881 382.756 166.804 382.756 167.766C382.756 168.728 382.374 169.651 381.694 170.332C381.013 171.012 380.09 171.394 379.128 171.394Z",
    fill: "#E3E3E3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M379.128 190.443H276.632C275.67 190.443 274.747 190.061 274.067 189.38C273.386 188.7 273.004 187.777 273.004 186.815C273.004 185.852 273.386 184.929 274.067 184.249C274.747 183.568 275.67 183.186 276.632 183.186H379.128C380.09 183.186 381.013 183.568 381.694 184.249C382.374 184.929 382.756 185.852 382.756 186.815C382.756 187.777 382.374 188.7 381.694 189.38C381.013 190.061 380.09 190.443 379.128 190.443Z",
    fill: "#E3E3E3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M379.128 209.491H276.632C275.67 209.491 274.747 209.108 274.067 208.428C273.386 207.747 273.004 206.825 273.004 205.862C273.004 204.9 273.386 203.977 274.067 203.297C274.747 202.616 275.67 202.234 276.632 202.234H379.128C380.09 202.234 381.013 202.616 381.694 203.297C382.374 203.977 382.756 204.9 382.756 205.862C382.756 206.825 382.374 207.747 381.694 208.428C381.013 209.108 380.09 209.491 379.128 209.491Z",
    fill: "#E3E3E3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M379.44 98.4368H334.088C333.126 98.4368 332.203 98.0546 331.523 97.3741C330.842 96.6937 330.46 95.7708 330.46 94.8085C330.46 93.8462 330.842 92.9233 331.523 92.2429C332.203 91.5625 333.126 91.1802 334.088 91.1802H379.44C380.403 91.1802 381.326 91.5625 382.006 92.2429C382.687 92.9233 383.069 93.8462 383.069 94.8085C383.069 95.7708 382.687 96.6937 382.006 97.3741C381.326 98.0546 380.403 98.4368 379.44 98.4368Z",
    fill: "#D6E5FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M379.44 117.484H334.088C333.126 117.484 332.203 117.102 331.523 116.421C330.842 115.741 330.46 114.818 330.46 113.856C330.46 112.894 330.842 111.971 331.523 111.29C332.203 110.61 333.126 110.228 334.088 110.228H379.44C380.403 110.228 381.326 110.61 382.006 111.29C382.687 111.971 383.069 112.894 383.069 113.856C383.069 114.818 382.687 115.741 382.006 116.421C381.326 117.102 380.403 117.484 379.44 117.484Z",
    fill: "#D6E5FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M312.128 125.554H277.294C276.157 125.553 275.066 125.158 274.262 124.455C273.457 123.752 273.005 122.799 273.004 121.805V85.8886C273.005 84.8947 273.457 83.9418 274.262 83.2391C275.066 82.5363 276.157 82.1411 277.294 82.14H312.128C313.265 82.1411 314.356 82.5363 315.16 83.2391C315.964 83.9418 316.417 84.8947 316.418 85.8886V121.805C316.417 122.799 315.964 123.752 315.16 124.455C314.356 125.158 313.265 125.553 312.128 125.554Z",
    fill: "#9FB3D6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1681_5110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.5674,
    y: 164.626,
    width: 134.44,
    height: 180.167,
    rx: 9.14555,
    fill: "#F1F4F8"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 105.545,
    cy: 120.898,
    r: 22.517,
    stroke: "#90CAF9",
    strokeWidth: 6.43343
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-31-inside-1_1681_5110",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.279 120.898C131.279 124.277 130.613 127.623 129.32 130.745C128.027 133.868 126.131 136.704 123.742 139.094C121.352 141.484 118.515 143.379 115.393 144.672C112.271 145.966 108.925 146.631 105.545 146.631L105.545 140.258C108.088 140.258 110.605 139.758 112.954 138.785C115.303 137.812 117.438 136.385 119.235 134.588C121.033 132.79 122.459 130.656 123.432 128.307C124.405 125.958 124.906 123.44 124.906 120.898H131.279Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131.279 120.898C131.279 124.277 130.613 127.623 129.32 130.745C128.027 133.868 126.131 136.704 123.742 139.094C121.352 141.484 118.515 143.379 115.393 144.672C112.271 145.966 108.925 146.631 105.545 146.631L105.545 140.258C108.088 140.258 110.605 139.758 112.954 138.785C115.303 137.812 117.438 136.385 119.235 134.588C121.033 132.79 122.459 130.656 123.432 128.307C124.405 125.958 124.906 123.44 124.906 120.898H131.279Z",
    stroke: "#106EBE",
    strokeWidth: 12.8669,
    mask: "url(#path-31-inside-1_1681_5110)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.212,
    cy: 21.3334,
    r: 13.9011,
    transform: "rotate(-68.517 328.212 21.3334)",
    stroke: "#90CAF9",
    strokeWidth: 3.97174
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-33-inside-2_1681_5110",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.03 6.5502C335.971 7.31426 337.743 8.45321 339.244 9.90204C340.746 11.3509 341.947 13.0812 342.779 14.9942C343.612 16.9072 344.059 18.9655 344.096 21.0514C344.133 23.1374 343.759 25.2103 342.995 27.1516L339.334 25.7108C339.909 24.2502 340.19 22.6907 340.162 21.1213C340.135 19.5519 339.798 18.0034 339.172 16.5641C338.545 15.1248 337.642 13.823 336.512 12.733C335.383 11.643 334.05 10.7861 332.589 10.2113L334.03 6.5502Z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M334.03 6.5502C335.971 7.31426 337.743 8.45321 339.244 9.90204C340.746 11.3509 341.947 13.0812 342.779 14.9942C343.612 16.9072 344.059 18.9655 344.096 21.0514C344.133 23.1374 343.759 25.2103 342.995 27.1516L339.334 25.7108C339.909 24.2502 340.19 22.6907 340.162 21.1213C340.135 19.5519 339.798 18.0034 339.172 16.5641C338.545 15.1248 337.642 13.823 336.512 12.733C335.383 11.643 334.05 10.7861 332.589 10.2113L334.03 6.5502Z",
    stroke: "#106EBE",
    strokeWidth: 7.94347,
    mask: "url(#path-33-inside-2_1681_5110)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 550.886,
    cy: 120.33,
    r: 22.517,
    transform: "rotate(63.0878 550.886 120.33)",
    stroke: "#90CAF9",
    strokeWidth: 6.43343
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-35-inside-3_1681_5110",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.534 143.277C559.521 144.806 556.236 145.727 552.866 145.987C549.497 146.247 546.109 145.841 542.897 144.792C539.684 143.743 536.71 142.071 534.144 139.872C531.577 137.674 529.469 134.991 527.94 131.978L533.622 129.093C534.773 131.36 536.359 133.379 538.29 135.033C540.221 136.687 542.459 137.945 544.875 138.734C547.292 139.523 549.841 139.829 552.376 139.633C554.911 139.438 557.383 138.745 559.65 137.594L562.534 143.277Z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M562.534 143.277C559.521 144.806 556.236 145.727 552.866 145.987C549.497 146.247 546.109 145.841 542.897 144.792C539.684 143.743 536.71 142.071 534.144 139.872C531.577 137.674 529.469 134.991 527.94 131.978L533.622 129.093C534.773 131.36 536.359 133.379 538.29 135.033C540.221 136.687 542.459 137.945 544.875 138.734C547.292 139.523 549.841 139.829 552.376 139.633C554.911 139.438 557.383 138.745 559.65 137.594L562.534 143.277Z",
    stroke: "#106EBE",
    strokeWidth: 12.8669,
    mask: "url(#path-35-inside-3_1681_5110)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M156.632 261.966H54.1361C53.1739 261.966 52.251 261.584 51.5705 260.904C50.8901 260.223 50.5078 259.301 50.5078 258.338C50.5078 257.376 50.8901 256.453 51.5705 255.773C52.251 255.092 53.1739 254.71 54.1361 254.71H156.632C157.108 254.71 157.58 254.804 158.02 254.986C158.461 255.168 158.861 255.436 159.197 255.773C159.534 256.11 159.802 256.51 159.984 256.95C160.166 257.39 160.26 257.862 160.26 258.338C160.26 258.815 160.166 259.287 159.984 259.727C159.802 260.167 159.534 260.567 159.197 260.904C158.861 261.241 158.461 261.508 158.02 261.69C157.58 261.873 157.108 261.966 156.632 261.966Z",
    fill: "#E3E3E3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M156.632 281.014H54.1361C53.1739 281.014 52.251 280.632 51.5705 279.951C50.8901 279.271 50.5078 278.348 50.5078 277.386C50.5078 276.424 50.8901 275.501 51.5705 274.82C52.251 274.14 53.1739 273.758 54.1361 273.758H156.632C157.594 273.758 158.517 274.14 159.197 274.82C159.878 275.501 160.26 276.424 160.26 277.386C160.26 278.348 159.878 279.271 159.197 279.951C158.517 280.632 157.594 281.014 156.632 281.014Z",
    fill: "#E3E3E3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M156.632 300.063H54.1361C53.1739 300.063 52.251 299.681 51.5705 299C50.8901 298.32 50.5078 297.397 50.5078 296.435C50.5078 295.472 50.8901 294.549 51.5705 293.869C52.251 293.189 53.1739 292.806 54.1361 292.806H156.632C157.594 292.806 158.517 293.189 159.197 293.869C159.878 294.549 160.26 295.472 160.26 296.435C160.26 297.397 159.878 298.32 159.197 299C158.517 299.681 157.594 300.063 156.632 300.063Z",
    fill: "#E3E3E3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M156.632 319.111H54.1361C53.1739 319.111 52.251 318.728 51.5705 318.048C50.8901 317.367 50.5078 316.444 50.5078 315.482C50.5078 314.52 50.8901 313.597 51.5705 312.917C52.251 312.236 53.1739 311.854 54.1361 311.854H156.632C157.594 311.854 158.517 312.236 159.197 312.917C159.878 313.597 160.26 314.52 160.26 315.482C160.26 316.444 159.878 317.367 159.197 318.048C158.517 318.728 157.594 319.111 156.632 319.111Z",
    fill: "#E3E3E3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M156.945 208.056H111.593C110.631 208.056 109.708 207.674 109.028 206.994C108.347 206.313 107.965 205.39 107.965 204.428C107.965 203.466 108.347 202.543 109.028 201.863C109.708 201.182 110.631 200.8 111.593 200.8H156.945C157.908 200.8 158.831 201.182 159.511 201.863C160.191 202.543 160.574 203.466 160.574 204.428C160.574 205.39 160.191 206.313 159.511 206.994C158.831 207.674 157.908 208.056 156.945 208.056Z",
    fill: "#D6E5FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M156.945 227.104H111.593C110.631 227.104 109.708 226.722 109.028 226.041C108.347 225.361 107.965 224.438 107.965 223.476C107.965 222.514 108.347 221.591 109.028 220.91C109.708 220.23 110.631 219.847 111.593 219.847H156.945C157.908 219.847 158.831 220.23 159.511 220.91C160.191 221.591 160.574 222.514 160.574 223.476C160.574 224.438 160.191 225.361 159.511 226.041C158.831 226.722 157.908 227.104 156.945 227.104Z",
    fill: "#D6E5FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6315 235.174H54.798C53.6605 235.173 52.57 234.778 51.7657 234.075C50.9614 233.372 50.509 232.419 50.5078 231.425V195.509C50.509 194.515 50.9614 193.562 51.7657 192.859C52.57 192.156 53.6605 191.761 54.798 191.76H89.6315C90.7689 191.761 91.8594 192.156 92.6637 192.859C93.468 193.562 93.9204 194.515 93.9216 195.509V231.425C93.9204 232.419 93.468 233.372 92.6637 234.075C91.8594 234.778 90.7689 235.173 89.6315 235.174Z",
    fill: "#9FB3D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_1681_5110",
    x: 240.443,
    y: 411,
    width: 170.399,
    height: 225.752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.17069
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.17069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1681_5110"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.25604
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.17069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1681_5110",
    result: "effect2_dropShadow_1681_5110"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08535
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71336
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1681_5110",
    result: "effect3_dropShadow_1681_5110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1681_5110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1681_5110",
    x: 478.6,
    y: 159.666,
    width: 144.36,
    height: 190.088,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.48017
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1681_5110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1681_5110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1681_5110",
    x: 256.103,
    y: 50.0461,
    width: 144.36,
    height: 190.088,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.48017
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1681_5110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1681_5110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1681_5110",
    x: 33.607,
    y: 159.666,
    width: 144.36,
    height: 190.088,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.48017
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1681_5110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1681_5110",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.2e675701e928999edf15d4f3843653af.svg";
export { ForwardRef as ReactComponent };